"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCrmClientType = normalizeCrmClientType;
exports.canAccessCrmClientType = canAccessCrmClientType;
exports.getAllowedCrmClientTypes = getAllowedCrmClientTypes;
exports.getCrmClientTypeForRole = getCrmClientTypeForRole;
function normalizeCrmClientType(clientType) {
    return clientType ?? 'retivut';
}
function canAccessCrmClientType(role, clientType) {
    return normalizeCrmClientType(clientType) === 'retivut' || role.isAdmin || role.role === 'editor';
}
function getAllowedCrmClientTypes(role) {
    return canAccessCrmClientType(role, 'bedek') ? ['bedek', 'retivut'] : ['retivut'];
}
function getCrmClientTypeForRole(role, requestedClientType) {
    const requested = normalizeCrmClientType(requestedClientType);
    return canAccessCrmClientType(role, requested) ? requested : 'retivut';
}
